import "svix-react/dist/style.css";

import {
  Input,
  Button,
  Card,
  Col,
  Row,
  Typography,
  notification,
  Modal,
} from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { getSupaClient } from "../../lib/supabase";
import { useEffect, useState } from "react";
import { loadWebhookKey } from "../../lib/queries";
import { AppPortal } from "svix-react";

const { Text } = Typography;

// prep the embed to show on settings page
const SvixEmbed = (prop: { svixAppId: string }) => {
  // show error message if not set up

  const [appPortal, setAppPortal] = useState(null);

  // get the app portal link
  useEffect(() => {
    fetch(`${process.env["REACT_APP_API"]}/svixmagiclink`, {
      method: "POST",
      body: JSON.stringify({ app: prop.svixAppId }),
    })
      .then((res) => res.json())
      .then((result) => {
        setAppPortal(result);
      });
  }, [prop.svixAppId]);
  if (!prop.svixAppId) {
    return <div>Not setup. Please contact support through chat!</div>;
  }

  return <AppPortal url={(appPortal as any)?.url} />;
};

/**
 * Displays integrations settings for slack and discord
 * @returns JSX
 */
export default function () {
  const [isAddEndpointsModalVisible, setIsAddEndpointsModalVisible] =
    useState(false);
  const [appId, setAppId] = useState(null);
  const [integKey, setIntegKey] = useState(null);
  const teamId = localStorage.getItem("team-id");
  const currentPlatform = localStorage.getItem("platform") as
    | "slack"
    | "discord"
    | null;
  const [dotsAPIKey, setDotsAPIKey] = useState(null);

  const supaClient = getSupaClient();

  // load webhook api id and integ key
  const loadWebhook = async () => {
    const { appId, integKey } = await loadWebhookKey();
    if (appId && integKey) {
      setAppId(appId);
      setIntegKey(integKey);
    }
  };

  // open copy notification
  const openKeyCopyNotification = () => {
    notification.open({
      message: "Copied to clipboard!",
    });
    window.analytics.track("Zapier key copied");
  };

  // load Dots api key
  const loadDotsAPI = async () => {
    const { data, error } = await supaClient
      .from("teams")
      .select("api_key")
      .eq("slack_id", teamId);
    if (data && data[0]?.api_key) {
      setDotsAPIKey(data[0].api_key);
    }
    if (error) {
      console.log("Error no api", error);
    }
  };

  // check if the user has a strip customer id
  useEffect(() => {
    document.title = "Settings | Dots";
    loadDotsAPI();
    loadWebhook();
  }, []);

  return (
    <div>
      <Row style={{ paddingBottom: 40 }}>
        <Col span={12}>
          <Card title="API key" bordered={false}>
            {dotsAPIKey ? (
              <div>
                <h3>
                  Your API Key: <Text code>{dotsAPIKey}</Text>
                </h3>
                <div className="bg-gray-100 rounded-md p-3 mt-5">
                  <strong>Note:</strong> We strongly recommend using a secrets
                  manager. Plain text files like dotenv lead to accidental
                  costly leaks.
                </div>
              </div>
            ) : (
              "Please reach out to get API access! "
            )}

            <p>
              You can find the Dots app in Zapier through{" "}
              <a
                href="https://zapier.com/developer/public-invite/159040/4b2f4c51fd6b15801b6ba251a448d30e/"
                target="_blank"
                rel="noreferrer"
              >
                this link
              </a>
            </p>
            <h4 style={{ margin: "1rem 0 1rem 0" }} className="mt-4">
              Credentials for Zapier
            </h4>
            {appId && integKey ? (
              <div>
                {" "}
                <div>
                  <div>
                    <p>
                      <strong>Application ID</strong>
                    </p>
                    <Input
                      prefix={
                        <button
                          onClick={() => {
                            navigator.clipboard
                              .writeText(appId)
                              .then(() => openKeyCopyNotification());
                          }}
                        >
                          <CopyOutlined className="site-form-item-icon" />
                        </button>
                      }
                      style={{
                        width: "15rem",
                        margin: "0 0 1rem 0",
                        cursor: "pointer",
                      }}
                      value={appId}
                      onChange={() => setAppId(appId)}
                    />
                  </div>
                  <div>
                    <p>
                      <strong>Integration Key</strong>
                    </p>
                    <Input.Password
                      prefix={
                        <button
                          onClick={() =>
                            navigator.clipboard
                              .writeText(integKey)
                              .then(() => openKeyCopyNotification())
                          }
                        >
                          <CopyOutlined className="site-form-item-icon" />
                        </button>
                      }
                      style={{
                        width: "15rem",
                        margin: "0 0 1rem 0",
                        cursor: "pointer",
                      }}
                      value={integKey}
                      onChange={() => setIntegKey(integKey)}
                    />
                  </div>
                </div>
                <Button onClick={() => setIsAddEndpointsModalVisible(true)}>
                  Zapier webhook logs
                </Button>
              </div>
            ) : (
              <p>Not setup. Please contact support through chat!</p>
            )}
          </Card>
        </Col>
      </Row>
      <Modal
        title="Zapier logs"
        onCancel={() => setIsAddEndpointsModalVisible(false)}
        visible={isAddEndpointsModalVisible}
        footer={null}
        width={1000}
      >
        <div style={{ height: 500, display: "flex" }}>
          <SvixEmbed svixAppId={appId || ""} />
        </div>
      </Modal>
    </div>
  );
}
